import { accAPI } from "..";
import { separateAffAbo } from "../../common/util/abo";
import {
  PathToBronzeOverviewParam,
  PathToBronzeOverviewResponse,
  PathToBronzePaymentDetailsParam,
  PathToBronzePaymentDetailsResponse,
  BronzeOverviewParam,
  BronzeOverviewResponse,
} from "./bronzeIncentivesAPI.types";
import { BronzeOverviewV2Param, BronzeOverviewV2Response } from "./bronzeIncentivesV2API.types";

export const bronzeAPI = accAPI.injectEndpoints({
  endpoints: (build) => ({
    getBronzeOverview: build.query<BronzeOverviewResponse, BronzeOverviewParam>({
      query: (params) => {
        const {
          affAbo,
          period,
          awardCode,
          fixedPayment,
          restart1,
          restart2,
          locale,
          isoCountryCode,
          isoCurrencyCode,
          isStandarRetailEnhancementCountry,
        } = params;
        const queryParams = new URLSearchParams({
          affAbo,
          period,
          awardCode: `${awardCode}`,
          locale,
          isoCountryCode,
          isoCurrencyCode,
          isStandarRetailEnhancementCountry: `${isStandarRetailEnhancementCountry}`,
        });

        // optional fields
        if (restart1 !== void 0) {
          queryParams.append("restart1", `${restart1}`);
        }

        if (restart2 !== void 0) {
          queryParams.append("restart2", `${restart2}`);
        }

        if (fixedPayment) {
          queryParams.append("fixedPaymentAwardCode", `${fixedPayment}`);
        }

        return `/incentives-v2/api/bronze/overview?${queryParams}`;
      },
    }),
    getPathToBronzeOverview: build.query<PathToBronzeOverviewResponse, PathToBronzeOverviewParam>({
      query: (params) => {
        const { affAbo, period, locale, countryCode } = params;
        const queryParams = new URLSearchParams({
          affAbo,
          period,
          locale,
          countryCode,
        });
        return `/incentives-v2/api/ptb/overview?${queryParams}`;
      },
    }),
    getPathToBronzePaymentDetails: build.query<PathToBronzePaymentDetailsResponse, PathToBronzePaymentDetailsParam>({
      query: (params) => {
        const { AffAbo, Period, IsoCountryCode, IsoCurrencyCode, Locale } = params;
        const { aff, abo } = separateAffAbo(AffAbo);
        const formattedAffAbo = `${aff}-${abo}`;
        const queryParams = new URLSearchParams({
          AffAbo: formattedAffAbo,
          Period: Period.toString(),
          IsoCountryCode,
          IsoCurrencyCode,
          Locale,
        });
        return `/incentives-v2/api/ptb/ptb-payment-details?${queryParams}`;
      },
    }),
    getBronzeOverviewV2: build.query<BronzeOverviewV2Response, BronzeOverviewV2Param>({
      query: (params) => {
        const {
          AffAbo,
          Period,
          AwardCode,
          ConsistencyPayment,
          Restart1,
          Restart2,
          Locale,
          IsoCountryCode,
          IsoCurrencyCode,
          IsStandarRetailEnhancementCountry,
        } = params;
        const queryParams = new URLSearchParams({
          AffAbo,
          Period,
          AwardCode: `${AwardCode}`,
          Locale,
          IsoCountryCode,
          IsoCurrencyCode,
          IsStandarRetailEnhancementCountry: `${IsStandarRetailEnhancementCountry}`,
        });

        // optional fields
        if (Restart1 !== void 0) {
          queryParams.append("Restart1", `${Restart1}`);
        }

        if (Restart2 !== void 0) {
          queryParams.append("Restart2", `${Restart2}`);
        }

        if (ConsistencyPayment) {
          queryParams.append("ConsistencyPayment", `${ConsistencyPayment}`);
        }

        return `/incentives-v2/api/bronze/overviewv2?${queryParams}`;
      },
    }),
  }),
});

export const {
  useGetBronzeOverviewQuery,
  useGetPathToBronzeOverviewQuery,
  useGetPathToBronzePaymentDetailsQuery,
  useGetBronzeOverviewV2Query,
} = bronzeAPI;
